import MonitorManager from './Monitor/MonitorManager';

const ErrorMonitor = {
	capture(error) {
		MonitorManager.captureException(error);
	},
};

export default ErrorMonitor;
